<template>
  <div style="display: inline-block; margin: 0px; padding: 0px">
    <el-button
      size="small"
      type="primary"
      class="btn"
      @click="syncDevice()"
      :loading="loading"
      ><span>{{ 'USB读取' }}</span>
      <img src="../assets/usb_white.png" height="25" width="25"
    /></el-button>
    <el-button
      size="small"
      type="primary"
      class="btn"
      @click="syncWirelessDeviceData()"
      ><span>{{ 'Wi-Fi读取' }}</span>
      <img src="../assets/wireless_connection_white.png" height="32" width="32"
    /></el-button>
  </div>
</template>

<script>
/**
 * 此组件有'read' emit，会带一个直接包括所有读取的颜色信息
 */

import { getWirelessDeviceData, syncDevice } from '../api/modules/product'
import { setDeviceState } from '@/api/modules/device'
import { getQueryString } from '@/utils/index'

export default {
  components: {},
  data: () => ({
    loading: false,
    websock: null,
    timer: null, //首先我在data函数里面进行定义定时器名称：
    timer_: null, //首先我在data函数里面进行定义定时器名称：
    timerNum: 0 // 设置定时器时间
  }),
  methods: {
    //设备同步
    syncDevice() {
      this.loading = true
      var id = getQueryString(location.href, 'deviceId')
      console.log(id)
      if (
        null == id ||
        '' == id ||
        getQueryString(location.href, 'connectionType') == 1
      ) {
        this.loading = false
        this.handleDeviceBoot()
        return
      }
      let params = {
        deviceId: getQueryString(location.href, 'deviceId')
      }
      syncDevice(params).then(({ data }) => {
        if (data && data.code === 0) {
          this.initWebSocket()
          this.timer = setInterval(() => {
            //如果已经同步就关闭定时任务
            this.$message.warning('数据同步中，请确认设备是否有待同步数据')
            this.timerNum = this.timerNum + 1
            if (this.timerNum == 5) {
              this.clearTimer() // 关闭定时器
              this.setDeviceState()
              this.loading = false
              this.$emit('readError', '设备连接超时')
            }
          }, 5000)
        } else {
          this.$emit('readError', data.msg)
          this.$message.error(data.msg)
          this.loading = false
        }
      })
    },
    initWebSocket() {
      //初始化weosocket
      //ws地址
      if (this.websock) {
        this.websock.close()
      }
      var id = getQueryString(location.href, 'deviceId')
      var wsuri = process.env.VUE_APP_WS_API + '/websocket/search_product_' + id
      this.websock = new WebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onerror = this.websocketonerror
      this.websock.onopen = this.websocketonopen
      //this.websock.onclose = this.websocketclose
    },
    websocketonmessage(e) {
      //数据接收
      console.log('RECEIVED WESOCKET:')
      console.log(e)
      //code:0.搜索产品,1.状态变更,2.连接成功
      //msg:
      //data:
      var retData = JSON.parse(e.data)
      var code = retData.code
      console.log(code)
      var msg = retData.msg
      console.log(msg)
      var data = retData.data
      console.log(data)
      if (code == 0) {
        let readData = {
          hex: data.hex,
          lAve: data.lAve,
          aAve: data.aAve,
          bAve: data.bAve,
          l1: data.l1,
          a1: data.a1,
          b1: data.b1,
          l2: data.l2,
          a2: data.a2,
          b2: data.b2,
          l3: data.l3,
          a3: data.a3,
          b3: data.b3
        }

        this.$emit('read', readData)

        this.clearTimer() // 关闭定时器
        this.loading = false
        this.websock.close()
        this.$message.success('同步成功')
      }
    },
    clearTimer() {
      //清除定时器
      window.clearInterval(this.timer)
      this.timer = null
      this.timerNum = 0
    },
    websocketonopen() {
      // 连接建立之后执行send方法发送数据
      // let data = {
      //   code: 0,
      //   msg: '这是client：初次连接'
      // }
      // this.websocketsend(JSON.stringify(data))
    },
    websocketsend(agentData) {
      //数据发送
      this.websock.send(agentData)
    },
    websocketonerror() {
      this.$emit('readError', 'WebSocket连接失败')
      return this.$message.error('WebSocket连接失败')
    },
    websocketclose(e) {
      //关闭
      this.websock.close()
      console.log('connection closed (' + e.code + ')')
    },
    setDeviceState() {
      let params = {
        deviceId: getQueryString(location.href, 'deviceId')
      }
      setDeviceState(params)
    },
    syncWirelessDeviceData() {
      var deviceId = getQueryString(location.href, 'deviceId')
      if (
        null == deviceId ||
        '' == deviceId ||
        getQueryString(location.href, 'connectionType') != '1'
      ) {
        this.loading = false
        this.handleDeviceBoot(false)
        return
      }
      getWirelessDeviceData({ deviceId: deviceId }).then(({ data }) => {
        if (data && data.code === 0) {
          if (data.LABvalue) {
            let readData = {
              hex: data.hex,
              lAve: data.LABvalue.lAve,
              aAve: data.LABvalue.aAve,
              bAve: data.LABvalue.bAve,
              l1: data.LABvalue.l1,
              a1: data.LABvalue.a1,
              b1: data.LABvalue.b1,
              l2: data.LABvalue.l2,
              a2: data.LABvalue.a2,
              b2: data.LABvalue.b2,
              l3: data.LABvalue.l3,
              a3: data.LABvalue.a3,
              b3: data.LABvalue.b3,
              secondsAgo: data.secondsAgo
            }
            this.$emit('read', readData)
          } else {
            this.$emit('readError', '无数据')
            this.$message.error('无数据')
          }
        } else {
          this.$emit('readError', '无数据')
          this.$message.error('无数据')
        }
      })
    },
    //设备引导
    handleDeviceBoot(isUsb = true) {
      this.$message.error(isUsb ? 'USB' + '设备未链接' : 'Wi-Fi' + '设备未链接')
    }
  }
}
</script>
<style lang="scss" scoped>
.btn {
  padding: 0px;
  height: 32px;
  margin: 2px;
  span {
    height: 100%;
    padding: 10px 4px 10px 10px;
    display: inline-block;
    margin: 0px;
  }
  img {
    margin: 0px 6px 3px 0px;
    vertical-align: middle;
  }
}
</style>